"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationLocation = void 0;
const Address_1 = require("../../../common/domain/Address");
const infrastructure_1 = require("../../../infrastructure");
const validator_1 = require("@leavy/validator");
const utils_1 = require("@leavy/utils");
class AccommodationLocation extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.address)
            && utils_1.Guard.isNotNullish(this.floor)
            && utils_1.Guard.isNotNullish(this.elevator));
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => Address_1.Address),
    __metadata("design:type", Address_1.Address)
], AccommodationLocation.prototype, "address", void 0);
exports.AccommodationLocation = AccommodationLocation;
//# sourceMappingURL=AccommodationLocation.js.map